<template>
  <div class="filter-item">
    <el-select v-model="item.field" size="mini" placeholder="选择指标" class="field-select" @change="onFieldChange">
      <el-option-group v-for="grp in dictGroups" :key="grp.key" :label="grp.label">
        <el-option v-for="f in grp.fields" :key="f.key" :label="f.label" :value="f.key" />
      </el-option-group>
    </el-select>

    <el-select v-model="item.operator" size="mini" placeholder="操作符" class="op-select" :disabled="!item.field" @change="onOperatorChange">
      <el-option v-for="op in currentOps" :key="op" :label="getOpLabel(op)" :value="op" />
    </el-select>

    <div class="value-input">
      <!-- Number BETWEEN -->
      <template v-if="item.operator === 'BETWEEN' && currentMeta && currentMeta.type === 'number'">
        <el-input-number :value="item.value && item.value[0]" size="mini" :controls="false" placeholder="最小值" @input="val => updateBetween(0, val)" />
        <span class="value-split">至</span>
        <el-input-number :value="item.value && item.value[1]" size="mini" :controls="false" placeholder="最大值" @input="val => updateBetween(1, val)" />
      </template>
      <!-- Date BETWEEN -->
      <template v-else-if="item.operator === 'BETWEEN' && currentMeta && currentMeta.type === 'date'">
        <el-date-picker v-model="item.value" type="daterange" size="mini" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始" end-placeholder="结束" style="width:100%;" />
      </template>
      <!-- Enum with IN (multi-select) -->
      <template v-else-if="currentMeta && currentMeta.options && item.operator === 'IN'">
        <el-select v-model="item.value" multiple size="mini" filterable collapse-tags placeholder="请选择" class="value-select">
          <el-option v-for="opt in currentMeta.options" :key="opt" :label="opt" :value="opt" />
        </el-select>
      </template>
      <!-- Enum with = (single select) -->
      <template v-else-if="currentMeta && currentMeta.options && (item.operator === '=' || item.operator === 'CONTAINS')">
        <el-select v-model="item.value" size="mini" filterable allow-create placeholder="请选择" class="value-select">
          <el-option v-for="opt in currentMeta.options" :key="opt" :label="opt" :value="opt" />
        </el-select>
      </template>
      <!-- Number input -->
      <template v-else-if="currentMeta && currentMeta.type === 'number'">
        <el-input-number v-model="item.value" size="mini" :controls="false" placeholder="请输入" />
      </template>
      <!-- Date single -->
      <template v-else-if="currentMeta && currentMeta.type === 'date'">
        <el-date-picker v-model="item.value" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%;" />
      </template>
      <!-- String/text input (default) -->
      <template v-else>
        <el-input v-model="item.value" size="mini" placeholder="请输入关键字" />
      </template>
    </div>

    <el-button icon="el-icon-close" circle size="mini" class="remove-btn" @click="$emit('remove')" />
  </div>
</template>

<script>
export default {
  name: 'CohortFilterItem',
  props: {
    item: { type: Object, required: true },
    diseaseDict: { type: Object, default: () => ({}) }
  },
  computed: {
    dictGroups() {
      const dict = this.diseaseDict;
      return Object.keys(dict).map(groupKey => ({
        key: groupKey,
        label: dict[groupKey].label,
        fields: Object.keys(dict[groupKey].fields).map(fieldKey => ({
          key: fieldKey,
          label: dict[groupKey].fields[fieldKey].label
        }))
      }));
    },
    currentMeta() {
      if (!this.item.field) return null;
      for (const groupKey in this.diseaseDict) {
        const fields = this.diseaseDict[groupKey].fields;
        if (fields[this.item.field]) {
          return fields[this.item.field];
        }
      }
      return null;
    },
    currentOps() {
      if (!this.currentMeta) return [];
      return this.currentMeta.ops || [];
    }
  },
  methods: {
    getOpLabel(op) {
      const map = {
        '=': '等于',
        '>': '大于',
        '<': '小于',
        'BETWEEN': '介于',
        'IN': '包含',
        'CONTAINS': '模糊匹配'
      };
      return map[op] || op;
    },
    onFieldChange(fieldKey) {
      const meta = this.currentMeta;
      if (meta) {
        this.$set(this.item, 'operator', meta.ops[0] || '');
        this._initValue(meta, meta.ops[0]);
      }
      this.$emit('field-change', this.item, fieldKey);
    },
    onOperatorChange(op) {
      if (this.currentMeta) {
        this._initValue(this.currentMeta, op);
      }
      this.$emit('operator-change', this.item, op);
    },
    _initValue(meta, operator) {
      let val;
      if (operator === 'IN') {
        val = [];
      } else if (operator === 'BETWEEN') {
        val = [null, null];
      } else if (meta.type === 'number') {
        val = null;
      } else {
        val = '';
      }
      this.$set(this.item, 'value', val);
    },
    updateBetween(index, val) {
      if (!this.item.value) {
        this.$set(this.item, 'value', [null, null]);
      }
      const newVal = [...this.item.value];
      newVal[index] = val;
      this.$set(this.item, 'value', newVal);
    }
  }
};
</script>

<style lang="less" scoped>
.filter-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
  gap: 6px;
  .field-select {
    width: 150px;
    flex-shrink: 0;
  }
  .op-select {
    width: 100px;
    flex-shrink: 0;
  }
  .value-input {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 180px;
    .value-split {
      color: #909399;
      font-size: 12px;
      flex-shrink: 0;
    }
    .value-select {
      flex: 1;
    }
  }
  .remove-btn {
    flex-shrink: 0;
    padding: 4px;
  }
}
</style>
